/* global Pikaday */
"use strict";
var moment = require('ofs/moment');
var $ = require('jquery');
var _ = require('underscore');

var React = require('react');

var UnitContactForm = require('ofs/components/contact/unit/component');
var GenericContactForm = require('ofs/components/contact/generic/component');
var BookingContactForm = require('ofs/components/contact/booking/component');
var SearchContactForm = require('ofs/components/contact/search/component');
var tracker = require('ofs/utils/Tracker/Tracker');

var pikadayI18n = require('ofs/pikaday-i18n');

import {trackOptimizelyOpen as trackOptimizelyOpen} from 'ofs/apps/core/utils/tracking/optimizely';
import {init as simpleChoiceInit} from 'ofs/components/simple-choice/SimpleChoice';

var valueToBool = function(value) {
  if (_.isBoolean(value)) {
    return value;
  }
  var boolMapper = {
    'true': true,
    'false': false,
    'yes': true,
    'no': false,
    't': true,
    'f': false,
    'y': true,
    'n': false,
    '1': true,
    '0': false
  };
  return boolMapper[value.toLowerCase()];
};

var simpleMapDefaults = {
    latitude: undefined,
    longitude: undefined,
    zoom: 12,
    hideControls: true
};

var initSimpleMap = function($el, opts) {
  var options = $.extend({}, simpleMapDefaults, opts);

  var lat = options.latitude;
  var lng = options.longitude;
  var zoom = options.zoom;
  var hideControls = valueToBool(options.hideControls);
  var scrollWheel = typeof options.scrollWheel !== 'undefined' ? valueToBool(options.scrollWheel) : true;

  var latlng = new google.maps.LatLng(lat, lng);

  var map = new google.maps.Map($el[0], {
    zoom: zoom,
    center: latlng,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: hideControls,
    scrollwheel: scrollWheel
  });

  new google.maps.Marker({
    position: latlng,
    map: map
  });

  if (opts.polygon && _.isArray(opts.polygon)) {

    var bounds = new google.maps.LatLngBounds();

    var boundary = _.map(opts.polygon, function(coords) {
      return new google.maps.LatLng(coords[0], coords[1]);
    });

    _.each(boundary, function(point) {
      bounds.extend(point);
    });

    map.fitBounds(bounds);

    var polygon = new google.maps.Polygon({
      paths: boundary,
      strokeColor: "#EC1748",
      strokeOpacity: 0.75,
      strokeWeight: 3,
      fillColor: "#000",
      fillOpacity: 0.125
    });
    polygon.setMap(map);
  }
};

var initGoogleMap = function($el, opts) {
  var options = $.extend({}, simpleMapDefaults, opts);
  var scaleFactor = 0.5;
  var spriteWidth = 412;
  var spriteHeight = 226;

  var lat = options.latitude;
  var lng = options.longitude;
  var latlng = new google.maps.LatLng(lat, lng);
  var zoom = options.zoom;
  var hideControls = valueToBool(options.hideControls);
  var useHomeMarker = valueToBool(options.useHomeMarker);

  var mapCanvas = $el[0];

  var mapOptions = {
      center: latlng,
      zoom: zoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      clickableLabels: false,
      disableDefaultUI: hideControls,
      styles: [{
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{
              visibility: 'off'
          }]
      }]
  };

  var map = new google.maps.Map(mapCanvas, mapOptions);

  var homeMarkerImage = '';
  if (useHomeMarker) {
    homeMarkerImage = new google.maps.MarkerImage(
      ofs.static('images/maps/markers.png'),
      new google.maps.Size(52 * scaleFactor, 46 * scaleFactor),  // desired size
      new google.maps.Point(360 * scaleFactor, 0 * scaleFactor), // offset within the scaled sprite
      null,
      new google.maps.Size(spriteWidth * scaleFactor, spriteHeight * scaleFactor) // scaled size of the entire sprite
    );
  }
  new google.maps.Marker({
    position: latlng,
    map: map,
    icon: homeMarkerImage
  });
};

var pikaDayDefaults = {
    format: 'DD MMMM YYYY',
    fillWeeks: true,
    firstDay: 1,
    handle: true
};

var initPikaDay = function($el, opts) {
  $el.wrap('<div class="datepicker-wrapper" />');

  $el.attr('autocomplete', 'off');
  $el.attr('readonly', 'true');
  var icon = $el.after('<span class="icon-calendar"></span');

  var options = $.extend({}, pikaDayDefaults, opts);
  var minDate;

  if (options.minDate) {
    minDate = moment(options.minDate, options.format).toDate();
  } else {
    minDate = moment().toDate();
  }

  var picker = new Pikaday({
    field: $el.get(0),
    minDate: minDate,
    icon: icon.get(0),
    format: options.format,
    fillWeeks: valueToBool(options.fillWeeks),
    firstDay: options.firstDay,
    handle: options.handle,
    i18n: pikadayI18n
  });
  ofs.components.pikadayElements.push(picker);
  $el.data('picker', picker);
};

var select2Defaults = {
    allowClear: true,
    minimumResultsForSearch: 11,
    escape: false
};

var select2Formatters = {
  region: {
    result: function(data) {
      if (!data.id) {
        return data.text; // optgroup
      }

      if (data.text.split(' ')[0] === '--') {
        return '&nbsp;&nbsp;&nbsp;&nbsp;' + data.text.replace('-- ', '');
      } else if (data.text.split(' ')[0] === '##') {
        return '<span class="my-region-heading">' + data.text.replace('## ', '') + '</span>';
      }
    },
    selection: function(data) {
      if (!data.id) {
        return data.text; // optgroup
      }

      if (data.text.split(' ')[0] === '--') {
        return data.text.replace('-- ', '');
      } else if (data.text.split(' ')[0] === '##') {
        return data.text.replace('## ', '');
      }
    }
  },
  allRegions: {
    result: function(data) {
      if (!data.id) {
        return data.text; // optgroup
      }

      if (data.text.split(' ')[0] === '--') {
        return '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + data.text.replace('-- ', '');
      } else if (data.text.split(' ')[0] === '##') {
        return '<span class="my-region-heading">' + data.text.replace('## ', '&nbsp;&nbsp;&nbsp;&nbsp;') + '</span>';
      } else if (data.text.split(' ')[0] === '$$') {
        return '<span class="my-region-heading">' + data.text.replace('$$ ', '') + '</span>';
      }
    },
    selection: function(data) {
      if (!data.id) {
        return data.text; // optgroup
      }

      if (data.text.split(' ')[0] === '--') {
        return data.text.replace('-- ', '');
      } else if (data.text.split(' ')[0] === '##') {
        return data.text.replace('## ', '');
      } else if (data.text.split(' ')[0] === '$$') {
        return data.text.replace('$$ ', '');
      }
    }
  },
  sleeps: {
    result: function(data) {
      return data.text;
    },
    selection: function(data) {
      // <select> default value ("Bedrooms") has id = 0
      if (data.id == '0') {
        return data.text;
      } else {
        return data.text + '<span class="icon-inline icon-sleeps-nocircle"></span>';
      }
    }
  },
  bedrooms: {
    result: function(data) {
      return data.text;
    },
    selection: function(data) {
      // <select> default value ("Sleeps") has id = 0
      if (data.id == '0') {
        return data.text;
      } else {
        return data.text + '<span class="icon-inline icon-bedrooms-nocircle"></span>';
      }
    }
  }
};

var escapeMarkup = function(m) {
  return m;
};

var initSelect2 = function($el, opts) {
  var options = $.extend({}, select2Defaults, opts);
  $el.css({
    'width': $el.outerWidth() + 'px'
  });

  var initOpts = {
    allowClear: valueToBool(options.allowClear),
    minimumResultsForSearch: parseInt(options.minimumResultsForSearch, 10)
  };

  if (valueToBool(options.escape)) {
    initOpts.escapeMarkup = escapeMarkup;
  }

  if (options.formatter) {
    var formatter = select2Formatters[opts.formatter];
    if (formatter && formatter.result) {
      initOpts.formatResult = formatter.result;
    }
    if (formatter && formatter.selection) {
      initOpts.formatSelection = formatter.selection;
    }
  }

  if (options.placeholder) {
    initOpts.placeholder = options.placeholder;
  }

  $el.select2(initOpts);
};

var initLocationPicker = function($el) {

  var $lng = $el.find('[data-ofs-subcomponent=longitude]');
  var $lat = $el.find('[data-ofs-subcomponent=latitude]');
  var height = $el.height();

  var lat = parseFloat($lat.val());
  var lng = parseFloat($lng.val());
  var location = null;

  if (lat && lng) {
    location = new google.maps.LatLng(lat, lng);
  }

  $lat.hide();
  $lng.hide();

  var $searchInput = $('<input type="search" />');
  $searchInput.css('margin-bottom', '0');
  $el.append($searchInput);

  var $map = $('<div />');
  $map.height(height - $searchInput.outerHeight());
  $el.append($map);

  var autocomplete = new google.maps.places.Autocomplete($searchInput.get(0));

  var center, zoom;

  if (location) {
    center = location;
    zoom = 13;
  } else {
    center = new google.maps.LatLng(0, 0);
    zoom = 1;
  }

  var mapOptions = {
    center: center,
    zoom: zoom,
    disableDefaultUI: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP
  };
  var map = new google.maps.Map($map.get(0), mapOptions);

  autocomplete.setTypes(['geocode']);
  autocomplete.bindTo('bounds', map);

  var marker = new google.maps.Marker({
    position: location,
    map: map,
    draggable: true
  });

  google.maps.event.addDomListener($searchInput.get(0), 'keydown', function(e) {
    // Make sure we don't submit the form when selecting an auto-complete option
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  });

  var updatePosition = function(position) {
    $lng.val(position.lng().toString());
    $lat.val(position.lat().toString());
  };

  google.maps.event.addListener(autocomplete, 'place_changed', function() {
    var place = autocomplete.getPlace();

    if (place.geometry) {
      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);
      }
      marker.setPosition(place.geometry.location);
      updatePosition(place.geometry.location);
    }
  });

  google.maps.event.addListener(marker, 'drag', function(event) {
    updatePosition(event.latLng);
  });
};

var initPicture = function($el) {
  if (!$el.data('defer')) {
    var $spans = $el.find('span');
    var matches = [];

    $spans.each(function(index, elem) {
        var $span = $(elem);
        var media = $span.data('media');

        if(!media || (window.matchMedia && window.matchMedia(media).matches)){
            matches.push($span);
        }
    });

    // Find any existing img element in the picture element
    var $img = $el.find('img').eq(0);

    if (matches.length){
      var matchedEl = matches.pop();
      if (!$img.length || $img.parent()[0].nodeName === 'NOSCRIPT') {
        $img = $('<img />');
        $img.attr('alt', $el.data('alt'));
      }
      $img.attr('src', matchedEl.data('src'));
      if (matchedEl.data('width') && matchedEl.data('height')) {
        $img.attr('width', matchedEl.data('width'));
        $img.attr('height', matchedEl.data('height'));
      }
      matchedEl.append($img);
    } else if ($img){
      $img.remove();
    }
  }
};

var initResponsive = function($el, opts) {
    var $children = $el.children();

    $children.each(function(index, elem) {
        var $child = $(elem);
        var media = $child.data('media');

        if(!media || window.matchMedia(media).matches) {
            $child.find('[data-ofs-component]').data('defer', false);
        } else {
            $child.find('[data-ofs-component]').data('defer', true);
            $child.hide();
        }
    });

    $(window).on('resize', function() {
        $children.each(function(index, elem) {
            var $child = $(elem);

            var media = $child.data('media');

            if(!media || window.matchMedia(media).matches) {
                $child.show();
                $child.find('[data-ofs-component]').data('defer', false);
                initComponents($child);
            } else {
                $child.hide();
            }
        });
    });
};


var initEnquire = function($el, opts) {
  $el.off('click.enquire');
  $el.on('click.enquire', function(event) {
    event.preventDefault();
    var source = $(event.currentTarget).data('ofs-source') || 'unknown';
    trackOptimizelyOpen(source);
    tracker.openEnquiry(source);
    window.ofsFlux.actions.layers.addModal(<GenericContactForm source={source} />);
  });
};


var initBookingEnquire = function($el, opts) {
  $el.off('click.booking-enquire');
  $el.on('click.booking-enquire', function(event) {
    event.preventDefault();
    var source = $(event.currentTarget).data('ofs-source') || 'unknown';
    trackOptimizelyOpen(source);
    tracker.openEnquiry(source);
    window.ofsFlux.actions.layers.addModal(<BookingContactForm source={source} />);
  });
};


var initSearchEnquire = function($el, opts) {
  $el.off('click.search-enquire');
  $el.on('click.search-enquire', function(event) {
    event.preventDefault();
    var source = $(event.currentTarget).data('ofs-source') || 'unknown';
    trackOptimizelyOpen(source);
    tracker.openEnquiry(source);
    window.ofsFlux.actions.layers.addModal(<SearchContactForm source={source} />);
  });
};


var initUnitEnquire = function($el, opts) {
  $el.off('click.unit-enquire');
  $el.on('click.unit-enquire', function(event) {
    event.preventDefault();
    var source = $(event.currentTarget).data('ofs-source') || 'unknown';

    var initial = {
      first_name: opts['firstName'] || null,
      last_name: opts['lastName'] || null,
      start_date: opts['start-date'] || null,
      end_date: opts['end-date'] || null
    };

    var config = {
      city: opts.city,
      unit: opts.unit,
      unitShortCode: opts.unitShortCode,
      initial: initial,
      source: source
    };
    trackOptimizelyOpen(source);
    tracker.openEnquiry(source);
    window.ofsFlux.actions.layers.addModal(<UnitContactForm {...config}/>);
  });
};

$.fn.changeElementType = function(newType) {
    var newElements = [];

    $(this).each(function() {
        var attrs = {};

        $.each(this.attributes, function(idx, attr) {
            attrs[attr.nodeName] = attr.nodeValue;
        });

        var newElement = $("<" + newType + "/>", attrs).append($(this).contents());

        $(this).replaceWith(newElement);

        newElements.push(newElement);
    });

    return $(newElements);
};

var mediafieldDefaults = {
};

var initMediafield = function($el, opts) {
    $el.mediaLibrary();
};

var unitPickerDefaults = {
    minimumResultsForSearch: 10
};

var initUnitPicker = function($el, opts) {
    var options = $.extend({}, unitPickerDefaults, opts);
    $el.css({
        'width': $el.width() + 'px'
    });

    var initOpts = {
        allowClear: true,
        minimumResultsForSearch: parseInt(options.minimumResultsForSearch, 10),
        ajax: {
            url: ofs.publicAPI("units"),
            dataType: 'json',
            quietMillis: 100,
            data: function (term, page) {
                return {
                    q: term,
                    limit: 10,
                    offset: (page - 1) * 10,
                    format: 'json'
                };
            },
            results: function (data, page) {
                var more = false; // whether or not there are more results available
                var results = data.results;

                var choices = [];

                for (var i=0; i<results.length; i++) {
                    var obj = results[i];
                    choices.push({
                        id: obj.id,
                        text: obj.name,
                        library_path: obj.library_path
                    });
                }

                // notice we return the value of more so Select2 knows if more results can be loaded
                return {
                    results: choices,
                    more: more
                };
            }
        },
        initSelection: function(element, callback) {
            // the input tag has a value attribute preloaded that points to a preselected movie's id
            // this function resolves that id attribute to an object that select2 can render
            // using its formatResult renderer - that way the movie name is shown preselected
            var id=$(element).val();
            if (id!=="") {
                $.ajax(ofs.publicAPI("units")+id+"/", {
                    data: {
                        format: 'json'
                    },
                    dataType: "json"
                }).done(function(data) {
                    callback({
                        id: data.id,
                        text: data.name,
                        library_path: data.library_path
                    });
                });
            }
        },
        formatSelection: function(data) {
            $el.data('libraryPath', data.library_path);
            return data.text;
        }
    };

    $el.select2(initOpts);
};

var initUnitPicker2 = function($el, opts) {
    var choices = [];

    if ($el.val() && $el.data('label')) {
        choices.push({"id": parseInt($el.val(), 10), "name": $el.data('label')});
    }

    $el.selectize({
        maxItems: 1,
        //dropdownParent: "body",
        valueField: 'id',
        labelField: 'name',
        searchField: 'name',
        options: choices,
        create: false,
        load: function(query, callback) {
            if (!query.length) return callback();
            $.ajax({
                url: ofs.publicAPI("units"),
                type: 'GET',
                dataType: 'json',
                data: {
                    q: query,
                    limit: 10,
                    format: 'json'
                },
                error: function() {
                    callback();
                },
                success: function(res) {
                    callback(res.results);
                }
            });
        }
    });
};

var initAutogrowTextarea = function($el, opts) {
    $el.autogrow();
};

var initContributorPicker = function($el, opts) {
    var choices = [];

    if ($el.val() && $el.data('label')) {
        choices.push({"id": parseInt($el.val(), 10), "name": $el.data('label')});
    }

    $el.selectize({
        maxItems: 1,
        //dropdownParent: "body",
        valueField: 'id',
        labelField: 'name',
        searchField: 'name',
        options: choices,
        create: false,
        load: function(query, callback) {
            if (!query.length) return callback();
            $.ajax({
                url: ofs.privateAPI("contributors"),
                type: 'GET',
                dataType: 'json',
                data: {
                    q: query,
                    limit: 10,
                    format: 'json'
                },
                error: function() {
                    callback();
                },
                success: function(res) {
                    callback(res.objects);
                }
            });
        }
    });
};

var formatRegionResult = function(data) {
    if (!data.id) return data.text; // optgroup

    if (data.text.split(' ')[0] === '--') {
        return '&nbsp;&nbsp;&nbsp;&nbsp;' + data.text.replace('-- ', '');
    }
    else if (data.text.split(' ')[0] === '##')  {
        return '<span class="my-region-heading">' + data.text.replace('## ', '') + '</span>';
    }
};

var formatRegionSelection = function(data) {
    if (!data.id) return data.text; // optgroup

    if (data.text.split(' ')[0] === '--') {
        return data.text.replace('-- ', '');
    }
    else if (data.text.split(' ')[0] === '##')  {
        return data.text.replace('## ', '');
    }
};

var buildSelectChoices = function($el, cityCode, minDepth) {
    var url = ofs.privateAPI("regions") + '?limit=0&city=' + cityCode + '&depth__gte=' + minDepth;

    $.get(url, function(data) {
        var regions = data.objects;
        var cityRegion = _.findWhere(regions, {depth: 1});

        var choices = [];

        var tempNode = $('<div/>');

        $el.empty();

        if (cityRegion) {
            var cityOption = $('<option />');
            cityOption.text('## All regions');
            cityOption.attr('value', cityRegion.id);
            cityOption.prop('selected', true);

            tempNode.append(cityOption);
        }

        var groups = _.where(regions, {depth: 2});
        _.each(groups, function(group) {
            var groupOption = $('<option />');
            groupOption.text('## ' + group.name);
            groupOption.attr('value', group.id);

            tempNode.append(groupOption);

            _.each(_.where(regions, {depth: 3, parent: group.resource_uri }), function(region) {
                var option = $('<option />');
                option.attr('value', region.id);
                option.text('-- ' + region.name);
                tempNode.append(option);
            });
        });
        $el.html(tempNode.html());

        if (cityRegion) {
            $el.select2('val', cityRegion.id);
        } else {
            $el.select2('data', {
                id: null,
                text: 'No region selected'
            });
        }
    });
};

var initRegionPicker = function($el, opts) {
    var city = opts.city;

    var defaultOpts = {
        formatResult: formatRegionResult,
        formatSelection: formatRegionSelection
    };

    var currentVal = $el.val();

    if (opts.forCitypicker) {
        var $cityPicker = $el.closest('form').find('[name=' + opts.forCitypicker + ']');
        $cityPicker.on('change', function() {
            var val = $cityPicker.val();
            if (val) {
                $el.prop('disabled', false);
                $el.select2('enable');
                buildSelectChoices($el, val, opts.minDepth || 1);
            } else {
                $el.empty();
                $el.select2('data', {
                    id: null,
                    text: ''
                });
                $el.prop('disabled', true);
                $el.select2('disable');
            }
        });
        if (!currentVal) {
            $el.prop('disabled', true);
            $el.select2('disable');
        }
    }

    $el.width($el.width());
    $el.select2(defaultOpts);

    if (!$el.find('option[selected]').length) {
        $el.select2('data', {
            id: null,
            text: ''
        });
    }
};

var initCityPicker = function($el, opts) {
    $el.width($el.width());
    $el.select2({
        minimumResultsForSearch: 10
    });
};

var initCityPicker2 = function($el) {
  $el.selectize();
};


var buildRegionChoices = function(picker, xhr, city, region, minDepth) {
    picker.disable();
    picker.clearOptions();
    picker.load(function(callback) {
        xhr && xhr.abort();
        xhr = $.ajax({
            url: ofs.privateAPI("regions"),
            type: 'GET',
            dataType: 'json',
            data: {
                limit: 0,
                city: city,
                depth__gte: minDepth,
                format: 'json'
            },
            error: function() {
                callback();
            },
            success: function(res) {
                picker.enable();
                var regions = res.objects;
                var cityRegion = _.findWhere(regions, {depth: 1});
                var choices = [];
                var index = 0;

                if (cityRegion) {
                    cityRegion.order = index;
                    index++;
                    choices.push(cityRegion);
                }
                var groups = _.where(regions, {depth: 2});
                _.each(groups, function(group) {
                    group.order = index;
                    index++;
                    choices.push(group);

                    _.each(_.where(regions, {depth: 3, parent: group.resource_uri }), function(region) {
                        region.order = index;
                        index++;
                        choices.push(region);
                    });
                });
                callback(choices);

                if (!region) {
                    picker.setValue(cityRegion.id);
                } else {
                    picker.setValue(parseInt(region, 10));
                }

            }
        });
    });
}

var initRegionPicker2 = function($el, opts) {
    var $cityPicker = $el.closest('form').find('[name=' + opts.forCitypicker + ']');
    var $regionPicker;
    var regionPicker;
    var xhr;
    var city = $cityPicker.val();
    var region = $el.val();
    $el.val(null);

    $cityPicker.on('change', function() {
        var val = $cityPicker.val();
        buildRegionChoices(regionPicker, xhr, val, null, 1);
    });

    $regionPicker = $el.selectize({
        valueField: 'id',
        labelField: 'name',
        searchField: ['name'],
        maxItems: 1,
        sortField: [
            {field: "$score", direction: "desc"},
            {field: "order", direction: "asc"},
        ],
        render: {
            item: function(item, escape) {
                if (item.depth === 1) {
                    item.name = 'All Regions';
                }
                return '<div>' + escape(item.name) + '</div>';
            },
            option: function(item, escape) {
                if (item.depth === 1) {
                    item.name = 'All Regions';
                }
                return '<div class="depth-' + item.depth + '">' + escape(item.name) + '</div>';
            }
        }
    });

    regionPicker = $regionPicker[0].selectize;

    if (city) {
        buildRegionChoices(regionPicker, xhr, city, region, 1);
    }
};

var initTooltip = function($el, opts) {
  var tooltipInit = require("ofs/react/components/tooltip");

  var label = $el.data('label');
  var orientation = $el.data('orientation');

  var $container = $("<div></div>");
  $el.append($container);

  tooltipInit($container[0], {tetherTo:$el[0], label:label, orientation:orientation});
};

var DatePicker = require('ofs/components/daterange/DatePicker');
var DatePickerComponent = React.createClass({
  getInitialState() {
    return {
      value: null
    }
  },

  handleSelect(value) {
    this.setState({value})
  },

  render() {
    return <DatePicker name={this.props.name} placeholder={this.props.placeholder} flux={window.ofsFlux} onSelect={this.handleSelect} value={this.state.value} />
  }
});

var initNewDatepicker = function($el, opts) {
  React.render(
    <DatePickerComponent name={opts.name} placeholder={opts.placeholder} />,
    $el[0]
  );
}

var initSimpleChoice = function($el, opts) {
  simpleChoiceInit($el);
}

var components = {
  'enquire': initEnquire,
  'booking-enquire': initBookingEnquire,
  'search-enquire': initSearchEnquire,
  'unit-enquire': initUnitEnquire,
  'simple-map': initSimpleMap,
  'google-map': initGoogleMap,
  'datepicker': initPikaDay,
  'select': initSelect2,
  'picture': initPicture,
  'locationpicker': initLocationPicker,
  'responsive': initResponsive,
  'regionpicker2': initRegionPicker2,
  'unitpicker': initUnitPicker,
  'unitpicker2': initUnitPicker2,
  'autogrow': initAutogrowTextarea,
  'contributorpicker': initContributorPicker,
  'regionpicker': initRegionPicker,
  'citypicker': initCityPicker,
  'citypicker2': initCityPicker2,
  'pikadayElements': [],
  'tooltip': initTooltip,
  'newDatepicker': initNewDatepicker,
  'simpleChoice': initSimpleChoice
};

var initComponent = function($el) {
    var component = $el.data('ofs-component');
    components[component]($el, $el.data());
};

var initComponents = function($node) {
    $node.find('.mediacat-mediainput-widget').each(function(index, elem) {
        $(elem).mediacat();
    });
    $node.find('[data-ofs-component]').each(function(index, elem) {
        initComponent($(elem));
    });
};

module.exports = {
  initComponents: initComponents,
  initComponent: initComponent,
  components: components
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/legacy-components.jsx
 **/